import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const h = (n) => n.toString(16).padStart(2, '0').slice(-2);
const toHex = (c) => `#${h(c[0])}${h(c[1])}${h(c[2])}`;

const labelStyle = { fontSize: 11, paddingLeft: 1, paddingRight: 1, paddingTop: 0.2 };

const Legend = (props) => {
  const { sx, colors, min, max } = props;
  const colorSpecs = colors.map((c) => toHex(c)).join();
  sx.background = `linear-gradient(90deg, ${colorSpecs})`;

  return (
    <Box sx={sx}>
      <Typography sx={{ float: 'left', color: min.labelColor, ...labelStyle }}>{min.label}</Typography>
      <Typography sx={{ float: 'right', color: max.labelColor, ...labelStyle }}>{max.label}</Typography>
    </Box>
  );
};

export default Legend;
